import { UserResponseDtoRoleEnum } from '@app/api';
import clientBackground from '@app/assets/images/client-auth-background.svg';
import clientBackgroundMobile from '@app/assets/images/client-auth-background-mobile.svg';
import therapistBackground from '@app/assets/images/therapist-auth-background.svg';
import therapistBackgroundMobile from '@app/assets/images/therapist-auth-background-mobile.svg';
import { RoutesPath } from '@app/routers';

export const getBackgroundImageByRole = (role: UserResponseDtoRoleEnum) => {
  switch (role) {
    case UserResponseDtoRoleEnum.Therapist:
      return therapistBackground.src;
    case UserResponseDtoRoleEnum.Patient:
    default:
      return clientBackground.src;
  }
};

export const getMobileBackgroundImageByRole = (
  role: UserResponseDtoRoleEnum,
) => {
  switch (role) {
    case UserResponseDtoRoleEnum.Therapist:
      return therapistBackgroundMobile.src;
    case UserResponseDtoRoleEnum.Patient:
    default:
      return clientBackgroundMobile.src;
  }
};

export const getSignUpDataByRole = (
  role: UserResponseDtoRoleEnum,
): {
  href: RoutesPath;
  text: string;
} => {
  switch (role) {
    case UserResponseDtoRoleEnum.Patient:
      return {
        href: '/sign-up/therapist',
        text: 'Зарегистрироваться как специалист',
      };
    case UserResponseDtoRoleEnum.Therapist:
    default:
      return {
        href: '/sign-up/client',
        text: 'Зарегистрироваться как клиент',
      };
  }
};

export const getTitleByRole = (role: UserResponseDtoRoleEnum) => {
  switch (role) {
    case UserResponseDtoRoleEnum.Therapist:
      return 'Регистрация специалиста';
    case UserResponseDtoRoleEnum.Patient:
      return 'Регистрация клиента';
    default:
      return 'Зарегистрироваться';
  }
};
